import { render, staticRenderFns } from "./refereeDocumentList.vue?vue&type=template&id=85f6b25c&scoped=true"
import script from "./refereeDocumentList.vue?vue&type=script&lang=js"
export * from "./refereeDocumentList.vue?vue&type=script&lang=js"
import style0 from "./refereeDocumentList.vue?vue&type=style&index=0&id=85f6b25c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f6b25c",
  null
  
)

export default component.exports